// The following options are defined only in Typescript 4+ (lib.es2020.intl.d.ts)
const DEFAULT_OPTIONS: Intl.NumberFormatOptions = {
  notation: 'compact',
  compactDisplay: 'short',
}

export const formatNumber = (
  num: number,
  options: Intl.NumberFormatOptions = DEFAULT_OPTIONS
): string => {
  return Intl.NumberFormat('en', options).format(num)
}
